export default "#version 300 es\nprecision highp float;\n\nin vec4 vColor;\nout vec4 fragColor;\n\nvoid main() {\n  fragColor = vColor;\n}"